import createDataContext from "./createDataContext";
import mainReducer from "./mainReducer";
import mainAction from "./mainAction";

export const { Context, Provider } = createDataContext(mainReducer, mainAction, {});
